const CURRENCY = 'CURRENCY'
const TICKET = 'TICKET'
const INSURANCE = 'INSURANCE'
const OTHER = 'OTHER'

export default {
    CURRENCY,
    TICKET,
    INSURANCE,
    OTHER,
    list: [
        {
            name: 'Moeda',
            value: CURRENCY
        },
        {
            name: 'Passagem',
            value: TICKET
        },
        {
            name: 'Seguro',
            value: INSURANCE
        },
        {
            name: 'Outros',
            value: OTHER
        }
    ]
}
